
import type { IconProps } from 'src/types/icons';

const StartedIcon2 = (props: IconProps) => (
  <svg {...props} width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.70547 4.00371L0.724219 0.44375C0.651172 0.400781 0.575977 0.375 0.490039 0.375C0.255859 0.375 0.0646484 0.568359 0.0646484 0.804688H0.0625V8.19531H0.0646484C0.0646484 8.43164 0.255859 8.625 0.490039 8.625C0.578125 8.625 0.651172 8.59492 0.730664 8.55195L6.70547 4.99629C6.84727 4.87813 6.9375 4.6998 6.9375 4.5C6.9375 4.3002 6.84727 4.12402 6.70547 4.00371Z" fill="white" />
  </svg>

);
export default StartedIcon2;
